import React, { useEffect, useRef } from "react"
import { markdownToJSX } from '../../util/transforms'

export default ( {banner, setTopBannerOffsetHeight} ) => {

	if (typeof document === 'undefined' || !banner || !banner.active || !banner.text) { 
		return null
	}

	const body = document.body
	const bannerRef = useRef( null )

	// sets state in App.js that in turn passes it to Header.js so that we get correct placement of the header based on the lenght of the top banner text
	const setOffsetHeight = () => {
		if(bannerRef && bannerRef.current) {
			setTopBannerOffsetHeight( bannerRef.current.offsetHeight )			
		}
	}

	useEffect(() => {

		body.classList.add( 'o-top-banner-active' )		

		return () => {
			body.classList.remove( 'o-top-banner-active' )
			
		}
	}, [])

	useEffect(() => {
		setOffsetHeight()

		window.addEventListener('resize', setOffsetHeight )
		
		return () => {
			window.removeEventListener('resize', setOffsetHeight )
		}

	}, [bannerRef])

	return (
		<section className="o-top-banner u-center-text" ref={bannerRef} dangerouslySetInnerHTML={{ __html: banner.text }}></section>
	)	

}
